import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { DEAL_ORDER } from '../../../brands/default/constants';
import {
  SHOW_MARKETING_CLAIM_DEFINITIONS,
  SOCIAL_CUES,
} from '../../../brands/default/features';
import { MARKETING_CLAIMS_DEF_LINK } from '../../../brands/default/links';
import {
  getBackendSocialCueMessage,
  getRedTextDealSocialCue,
} from '../../../helpers/socialCues';
import ThemeContext from '../../../providers/ThemeProvider';

const DealSocialCueTop = ({
  order = DEAL_ORDER.odd,
  socialCueClaim = '',
  socialCuesData = {},
  className,
  containerExtraClasses,
  isMedium = false,
  isXS = false,
}) => {
  const theme = useContext(ThemeContext);
  const even = order === DEAL_ORDER.even;
  const MAX_STRING_LENGTH_XS_CARD = 25;

  if (!SOCIAL_CUES) return null;

  const socialCueMessage = !even && getBackendSocialCueMessage(socialCuesData);
  const socialAnotherCueMessage = getRedTextDealSocialCue({
    deal: {
      socialCueClaim,
    },
  });
  if (!socialCueMessage && !socialAnotherCueMessage) return null;

  const isLongMessage =
    socialCueMessage?.length > MAX_STRING_LENGTH_XS_CARD ||
    socialAnotherCueMessage?.length > MAX_STRING_LENGTH_XS_CARD;

  // xSmall and medium deal card, no room for long message
  if ((isXS || isMedium) && isLongMessage) return null;

  const showCueMessageTwo =
    !socialCueMessage &&
    socialAnotherCueMessage &&
    socialAnotherCueMessage.length;
  // && even; will appear less often, so lose this

  return (
    <>
      <div
        className={classNames(
          'social-cues-container__main-image__top',
          containerExtraClasses,
        )}
      >
        {socialCueMessage ? (
          <div className="social-cue__item">{socialCueMessage}</div>
        ) : null}

        {showCueMessageTwo ? (
          <div
            className={classNames('social-cue__item availability', className)}
          >
            <div className="social-text">{socialAnotherCueMessage}</div>
            {SHOW_MARKETING_CLAIM_DEFINITIONS && (
              <FontAwesomeIcon
                icon={faInfoCircle}
                onClick={(event) => {
                  event.stopPropagation();
                  window.open(MARKETING_CLAIMS_DEF_LINK, '_blank');
                }}
                size="sm"
                style={{
                  cursor: 'pointer',
                  marginLeft: '0.2rem',
                }}
              />
            )}
          </div>
        ) : null}
      </div>
      <style jsx>{`
        .social-cues-container__main-image__top {
          width: 100%;
          position: absolute;
          display: flex;
          align-items: center;
          top: 0;
          left: 0;
          z-index: 999;
          pointer-events: none;
        }
        .social-cues-container__main-image__top.margin-top {
          top: 30px;
        }
        .social-cues-container__main-image__top .social-cue__item {
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 10px auto;
          text-align: center;
          background-color: ${theme.colors.socialcuecolor.brandcolor};
          color: ${theme.colors.socialcuecolor.textonbrandcolor};
          font-weight: bold;
          border-radius: 20px;
          pointer-events: auto;
          padding: 2px 10px;
          height: 24px;
          font-size: ${isMedium || isXS ? '13px' : '14px'};
        }
        .social-cues-container__main-image__top
          .social-cue__item.position-left {
          margin: 10px;
        }

        .social-cues-container__main-image__top .social-cue__item.availability {
          background-color: ${theme.colors.socialcuecolor.primary};
          color: ${theme.colors.socialcuecolor.textonprimary};
        }
      `}</style>
    </>
  );
};

DealSocialCueTop.propTypes = {
  className: PropTypes.string,
  containerExtraClasses: PropTypes.string,
  isMedium: PropTypes.bool,
  isXS: PropTypes.bool,
  order: PropTypes.oneOf([DEAL_ORDER.odd, DEAL_ORDER.even]),
  socialCueClaim: PropTypes.string,
  socialCuesData: PropTypes.object,
};

export default DealSocialCueTop;
